import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import { useGetTranslations } from '@/composables/useGetTranslations';
import HowToUseRank from '@/components/HowToUse/HowToUseRank';
import validateObjectChain from '~/helpers/validateObjectChain';
import AzImg from '~/components/Atoms/AzImg.vue';
export default defineComponent({
  name: 'AppHowToUse',
  components: {
    HowToUseRank: HowToUseRank,
    AzImg: AzImg
  },
  props: {
    howToUse: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(props) {
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var howToUseItems = props.howToUse.filter(function (item) {
      return item.fields && Object.keys(item.fields).length > 0;
    });
    var getImageInfo = function getImageInfo(item) {
      var _item$fields, _item$fields$picto, _item$fields$picto$fi, _item$fields$picto$fi2, _item$fields2;
      return {
        url: (item === null || item === void 0 ? void 0 : (_item$fields = item.fields) === null || _item$fields === void 0 ? void 0 : (_item$fields$picto = _item$fields.picto) === null || _item$fields$picto === void 0 ? void 0 : (_item$fields$picto$fi = _item$fields$picto.fields) === null || _item$fields$picto$fi === void 0 ? void 0 : (_item$fields$picto$fi2 = _item$fields$picto$fi.file) === null || _item$fields$picto$fi2 === void 0 ? void 0 : _item$fields$picto$fi2.url) || '',
        alt: (item === null || item === void 0 ? void 0 : (_item$fields2 = item.fields) === null || _item$fields2 === void 0 ? void 0 : _item$fields2.title) || ''
      };
    };
    return {
      translate: translate,
      validateObjectChain: validateObjectChain,
      howToUseItems: howToUseItems,
      getImageInfo: getImageInfo
    };
  }
});